import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en    from './locales/en.json';
import es    from './locales/es.json';
import ptBR  from './locales/pt-BR.json';
import pt    from './locales/pt.json';
import el    from './locales/el.json';
import fr    from './locales/fr.json';
import it    from './locales/it.json';
import de    from './locales/de.json';
import pl    from './locales/pl.json';
import ru    from './locales/ru.json';
import ja    from './locales/ja.json';
import ko    from './locales/ko.json';
import zh    from './locales/zh.json';

const savedLang = localStorage.getItem('smilefy_lang') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en:    { translation: en },
      es:    { translation: es },
      'pt-BR': { translation: ptBR },
      pt:    { translation: pt },
      el:    { translation: el },
      fr:    { translation: fr },
      it:    { translation: it },
      de:    { translation: de },
      pl:    { translation: pl },
      ru:    { translation: ru },
      ja:    { translation: ja },
      ko:    { translation: ko },
      zh:    { translation: zh },
    },
    lng: savedLang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;

export const LANGUAGES = [
  { code: 'en',    label: 'English' },
  { code: 'es',    label: 'Español' },
  { code: 'pt-BR', label: 'Português (Brasil)' },
  { code: 'pt',    label: 'Português' },
  { code: 'el',    label: 'Ελληνικά' },
  { code: 'fr',    label: 'Français' },
  { code: 'it',    label: 'Italiano' },
  { code: 'de',    label: 'Deutsch' },
  { code: 'pl',    label: 'Polski' },
  { code: 'ru',    label: 'Русский' },
  { code: 'ja',    label: '日本語' },
  { code: 'ko',    label: '한국어' },
  { code: 'zh',    label: '中文' },
];
